export default __webpack_public_path__ + "static/media/texp4.622680bb.png";